module.exports = __webpack_public_path__ + "img/plus.b104819f.svg";